import React from "react";
import {FormattedMessage} from "react-intl";

export default ({i18n, defaultI18n, component}) => {
    const I18nComponent = component || FormattedMessage;
    return (
        <I18nComponent id={i18n || defaultI18n}/>
    )
};
